import { Typography } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Paper } from 'componets/ui';
import { RegistrationLayout } from 'componets/layouts';
import { TaxResidencyForm } from './TaxResidencyForm';

import { useAppSelector } from 'hooks';

import { ClientRole, Paths } from 'utils/constants';
import { language } from 'utils';

import { selectUser } from 'selectors';

import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-select.svg';

import styles from '../Register/index.module.scss';

export function TaxResidency() {
	const { t } = useTranslation();

	const user = useAppSelector(selectUser);
	const isEn = ['en','ro'].includes(language);

	const navigate = useNavigate();

	const LINKS = user.userType === ClientRole.COMPANY ? COMPANY_LINKS : USER_LINKS;

	return (
		<RegistrationLayout email={user.email} customClassName={styles.tax}>
			<div className={styles.form}>
				<Paper styleName={styles.blockForm}>
					<Typography.Title level={4} className={styles.contactInfo}>
						{t('taxResidencyFormTitleText')}
					</Typography.Title>

					<TaxResidencyForm />
				</Paper>
				<div
					className={classNames(styles.verifyLater, styles.verifyLaterFA)}
					role="button"
					onClick={() => navigate(Paths.OVERVIEW)}
				>
					<Typography.Text type="secondary">{t('specifyLaterText')}</Typography.Text>
				</div>
			</div>

			<div className={styles.links}>
				{LINKS.map((item) => (
					<Paper key={item.en} styleName={styles.paper}>
						<a href={isEn ? item.en : item.lt} target="_blank" rel="noreferrer">
							<span> {t(item.label)}</span> <ArrowIcon />
						</a>
					</Paper>
				))}
			</div>
		</RegistrationLayout>
	);
}

const USER_LINKS = [
	{
		label: 'taxResidencyFirstLinkText',
		en: 'https://crowdpear.com/help/is-the-income-earned-on-the-crowdpear-platform-taxed-non-lithuanian-tax-residents/',
		lt: 'https://crowdpear.com/lt/duk/ar-crowdpear-platformoje-uzdirbamos-pajamos-yra-apmokestinamos-ne-lietuvos-mokesciu-rezidentams/',
	},
	{
		label: 'taxResidencySecondLinkText',
		lt: 'https://crowdpear.com/lt/duk/ar-pajamos-gautos-crowdpear-yra-apmokestinamos-lietuvos-mokesciu-rezidentams/',
		en: 'https://crowdpear.com/help/is-the-income-earned-on-the-crowdpear-platform-taxed-lithuanian-tax-residents/',
	},
	{
		label: 'taxResidencyThirdLinkText',
		lt: 'https://crowdpear.com/lt/duk/kur-galiu-rasti-savo-identifikacini-mokesciu-moketojo-numeri/',
		en: 'https://crowdpear.com/help/where-can-i-find-my-tax-identification-number/',
	},
	{
		label: 'taxResidencyFourthLinkText',
		lt: 'https://crowdpear.com/lt/duk/kokius-dokumentus-turiu-pateikti-kad-sumazinciau-mano-valstybeje-mokamus-mokescius-das-1/',
		en: 'https://crowdpear.com/help/what-documents-do-i-need-to-submit-to-reduce-the-taxes-paid-in-my-own-country-das-1/',
	},
	{
		label: 'taxResidencyFifthLinkText',
		lt: 'https://crowdpear.com/lt/duk/kur-ir-kaip-galiu-ikelti-savo-das-1-forma/',
		en: 'https://crowdpear.com/help/where-and-how-can-i-upload-my-das-1-form/',
	},
];

const COMPANY_LINKS = [
	{
		label: 'taxResidencySixthLinkText',
		lt: 'https://crowdpear.com/lt/duk/ar-crowdpear-platformoje-juridiniams-asmenims-uzdirbamos-pajamos-yra-apmokestinamos-ne-lietuvos-juridiniams-asmenims/',
		en: 'https://crowdpear.com/help/is-the-income-earned-on-the-crowdpear-for-legal-entities-is-taxed-non-lithuanian-legal-entities/',
	},
	{
		label: 'taxResidencySeventhLinkText',
		lt: 'https://crowdpear.com/lt/duk/ar-crowdpear-platformoje-juridiniam-asmenims-uzdirbamos-pajamos-yra-apmokestinamos-lietuvos-juridiniams-asmenims/',
		en: 'https://crowdpear.com/help/is-the-income-earned-on-the-crowdpear-for-legal-entities-is-taxed-lithuanian-legal-entities/',
	},
];
